/*
 * ॐ नमः शिवाय
 * ಓಂ ನಮಃ ಶಿವಾಯ
 * ఓం నమః శివాయ
 * ஓம் நம சிவாய
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 *
 * You are free to use, modify, and distribute this software under the terms 
 * of the VIJAYA 1.0 License.
 *
 * MANDATORY ATTRIBUTION:
 * 1. The attribution to Rudra Coresoft Technologies Private Limited in this 
 *    copyright notice must not be removed even after modifications.
 * 2. For Free License usage, the footer phrases "Powered by arcee.io" and 
 *    "Developed by Rudra Coresoft" (plus logos) must remain visible.
 *
 * See the LICENSE file for the full text.
 */

import React from 'react';
import { useTheme } from '../../theme/ThemeContext';

function RoadmapSection() {
    const { theme } = useTheme();

    const roadmapItems = [
        {
            icon: 'bi-journal-text',
            title: 'Audit Trails',
            description: 'Full compliance history of every data change.'
        },
        {
            icon: 'bi-google',
            title: 'Social Login',
            description: 'SSO with Google, Microsoft, and LinkedIn.'
        },
        {
            icon: 'bi-cpu',
            title: 'Agentic AI',
            description: 'Autonomous agents to handle complex workflows.'
        },
        {
            icon: 'bi-shop',
            title: 'Marketplace',
            description: 'Publish Applications for other organizations to use. Make Additional Revenue.'
        }
    ];

    return (
        <section id="roadmap" className="roadmap-section" style={{ padding: '80px 0', background: '#fff' }}>
            <div className="container">
                <div style={{ textAlign: 'center', marginBottom: '48px' }}>
                    <h2 style={{ fontSize: '2.5rem', fontWeight: 700, color: theme.primary, marginBottom: '16px' }}>
                        Product Roadmap
                    </h2>
                    <p style={{ fontSize: '1.1rem', color: '#666' }}>
                        Innovating for the Future of Work.
                    </p>
                </div>

                <div className="row g-4">
                    {roadmapItems.map((item, index) => (
                        <div key={index} className="col-md-6 col-lg-3">
                            <div
                                style={{
                                    padding: '28px',
                                    background: '#f8f9fa',
                                    borderRadius: theme.cardRadius,
                                    height: '100%',
                                    textAlign: 'center'
                                }}
                            >
                                <i
                                    className={`${item.icon} mb-3`}
                                    style={{
                                        fontSize: '2.5rem',
                                        color: theme.secondary,
                                        display: 'block'
                                    }}
                                ></i>
                                <h5 style={{ fontWeight: 700, color: theme.primary, marginBottom: '12px' }}>
                                    {item.title}
                                </h5>
                                <p style={{ color: '#666', margin: 0, fontSize: '0.95rem', lineHeight: 1.6 }}>
                                    {item.description}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default RoadmapSection;
